import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import notify from 'devextreme/ui/notify';
import { NgForm, FormBuilder, FormGroup } from '@angular/forms';
import { User } from 'src/app/shared/models/users';
import { Company } from 'src/app/shared/models/companies';
import { DetailUsers } from 'src/app/shared/models/detailUsers';
import { UsersService } from 'src/app/shared/services/users.service';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import * as _ from 'lodash';
import { Level } from 'src/app/shared/enums/level.enum';
import { typeWithParameters } from '@angular/compiler/src/render3/util';

@Component({
  selector: 'app-users-program',
  templateUrl: './users-program.component.html',
  styleUrls: ['./users-program.component.scss']
})
export class UsersProgramComponent implements OnInit {
  Users: User[] = [];
  subscriptions: Subscription[] = [];
  companiesList: Company[] = [];
  companies: Company[];
  id_companies_list: any[] = [];
  emailDisabled: boolean;
  cdta: any;
  udata: any;
  tempBirthDate: any;
  genderOptions = [];

  @ViewChild('form') form: NgForm;
  
  

  constructor(
    private usersService: UsersService,
    private utilitiesService: UtilitiesService,
    private route: ActivatedRoute,
    private companiesService: CompaniesService,
    private router: Router,
    private ngZone: NgZone,
    private formBuilder: FormBuilder
  ) {
    console.log('Constructtor Usuarios Program Component !');
    this.udata = this.utilitiesService.getUserData();
    this.cdta = this.utilitiesService.getCompanyData();
    this.genderOptions = this.utilitiesService.getGenderOptions();
  }

  ngOnInit() {
    console.log('Usuarios Program Component !');
    this.initSubscriptions();
  }

  initSubscriptions() {
    this.subscriptions.push(
      this.companiesService.getCompanies().subscribe(companies => this.companiesList = companies)
    );
    
    switch (this.udata.level) {
      case Level.ihunterSuperUser:
      case Level.ihunterAdmin:
      case Level.ihunterReportes:
        this.subscriptions.push(
          this.usersService.getUsers().subscribe(users => {
            this.Users = users.filter(user => this.usersService.isLevel(user, [2,3,5,6]));
          })
        );
      break;
      case Level.CompanyAdmin:
      case Level.CompanyUser:
      case Level.CompanyReportes:
        this.subscriptions.push(
          this.usersService.getCompanyAdminUsers(this.cdta.id).subscribe(users => {
            this.Users = users.filter(user => this.usersService.isLevel(user, [2,3,5,6]));
          })
        );
      break;
      case Level.Broker:
        this.companies = this.udata.companyList ? this.udata.companyList : [];
        let companyIn = new Company();
        companyIn.id = this.cdta.id.trim();
        companyIn.companyName = this.cdta.companyName;
        this.companies.push(companyIn);
      
        if (this.udata.companyList) {
          this.udata.companyList.forEach(company => {
            this.id_companies_list.push(company.id.trim());
          });
        }
        this.id_companies_list.push(this.cdta.id.trim());
        this.subscriptions.push(
          this.usersService.getBrokerUsers(this.id_companies_list).subscribe(users => {
            this.Users = users.filter(user => this.usersService.isLevel(user, [2,3,5,6]));
          })
        );
      break;
      default:
      break;
    }
  }
  onEditingStart(e) {
    console.log(e);
    this.emailDisabled=true;
    this.tempBirthDate=e.data.birthDate;
    if (e.data.birthDate) {
      //e.data.birthDate = this.utilitiesService.dateToNumber(e.data.birthDate)
    }
  }
  updateUser(e) {
    console.log(e);
    const newUserData = e.newData;
    newUserData.birthDate = this.utilitiesService.numberToDate(newUserData.birthDate);
    newUserData.id = e.oldData.id;
    this.usersService.updateUser(newUserData).subscribe(res => {
      this.utilitiesService.notifyMe('Ejecutado exitosamente!', 'success');
    });
  }
  deleteData(e) {
    this.usersService.deleteUserApi(e).subscribe(res => {
      this.utilitiesService.notifyMe('Usuario eliminado exitosamente!', 'success');
    });
  }

 

  sendEmailBienvenida(user) {      
    this.usersService.sendEmailBienvenida([user.email]).toPromise()
    .then(res => {
      if(res.error) {
        notify(res.error.message, 'danger', 1000);
      } else {
        notify('Se ha enviado un correo electronico con la información para iniciar sesión', 'success', 1000);
      }
    })
    .catch(error => {
      console.log('ERROR');
      console.log(error);
    });
  }

  

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe);
  }

}
